import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const QRCanvas = styled.canvas<{ scale?: number }>`
  height: ${(props) =>
    Screen.widthRatio * 215 * (props?.scale || 1)}px !important;
  width: ${(props) =>
    Screen.widthRatio * 215 * (props?.scale || 1)}px !important;
`;
export default QRCanvas;
